export default __webpack_public_path__ + "static/media/flagSpain.d3c6e2c7.svg";